import useTranslation from 'next-translate/useTranslation';
import { Title } from '../Services/Title';

interface ExpertiseSectionProps {
  text: string;
}

function ExpertiseSection({ text }: ExpertiseSectionProps) {
  const { t } = useTranslation('services');

  return (
    <div className='space-y-8'>
      <Title title={t('services:Our Expertise')} />
      <div>{text}</div>
    </div>
  );
}

export default ExpertiseSection;
